import { useEffect, useState } from 'react';

import { getAccessRequestCapability } from '@atlassian/confluence-cross-join-third-party-nudges/services/request-capabilities';

import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

export type JpdAccessCapability =
	| Awaited<ReturnType<typeof getAccessRequestCapability>>
	| 'UNKNOWN';

export const useJpdAccessCapability = (): JpdAccessCapability => {
	const { cloudId } = useSessionData();
	const [accessCapability, setAccessCapability] = useState<JpdAccessCapability>('UNKNOWN');

	useEffect(() => {
		let isMounted = true;

		void getAccessRequestCapability('jira-product-discovery', cloudId).then(
			(capability) => {
				if (isMounted) {
					setAccessCapability(capability);
				}
			},
			() => undefined,
		);

		return () => {
			isMounted = false;
		};
	}, [cloudId]);

	return accessCapability;
};
